import { createApiClient, createMutation } from "@/api/utils";
import { FileSource } from "./File.model";

export const downloadFileMutation = createMutation<
    { presignedUrl: string },
    { fileId: string }
>(async ({ api, payload }) => {
    const response = await api.post(`/file/files/${payload.fileId}/download`);

    console.log(response, "download response");

    return response;
});

export const uploadFileMutation = createMutation<
    { fileId: string },
    {
        name: string;
        mimeType: string;
        contentType: string;
        file: File;
    }
>(
    async ({ api, payload }) => {
        if (!payload.file) {
            throw new Error("File is required");
        }

        const response = await api.post(`/file/uploads`, {
            name: payload.name,
            ancestorFileId: null,
            mimeType: payload.mimeType,
            documentType: "raw",
            source: FileSource.USER_UPLOADED,
            meta: { userReportedUploadType: payload.contentType },
        });

        const presignedUrl = response.presignedUrl;

        const s3 = createApiClient({ withCredentials: false });
        const fileContent = await payload.file.arrayBuffer();

        return s3.put(presignedUrl, fileContent, {
            headers: {
                "Content-Type": payload.mimeType,
            },
        });
    },
    {
        errorToast: {
            message: "Failed to upload file",
        },
        successToast: {
            message: "File uploaded successfully",
        },
        invalidates: ["/files"],
    },
);
